// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-modal-modal_card-OVQlA {
  width: 324px;
  height: auto;
  min-height: auto;
  max-height: 600px;
}

.customer-modal-modal_content-FwvZH {
  padding: 0px 20px 0px;
}

.customer-modal-detailItem_container-zYkHD {
  width: auto;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;
  padding: 18px 0px;
}

.customer-modal-detailItem_title-MRmGP {
  font-size: 15px;
  font-weight: normal;
}

.customer-modal-detailItem_text-OQWpa {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.75);
}

.customer-modal-linkSection-sQZ4C {
  margin-top: 16px;
}

.customer-modal-linkHeader-pvXkZ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.customer-modal-active-SUQ69 {
  flex-shrink: 0;
  color: var(--color-green-700);
  font-size: 12px;
  font-weight: 500;
  background-color: var(--color-green-50);
  border-radius: var(--radius-xl);
  padding: 5px 9px;
}

.customer-modal-linkTitle-vqSPD {
  color: var(--color-neutral-800);
  font-size: 15px;
}

.customer-modal-linkRow-oHyk2 {
  display: flex;
  min-width: 0px;
  align-items: flex-start;
  gap: 8px;
  background-color: var(--color-gray-100);
  border-radius: var(--radius-lg);
  padding: 7px 7px 7px 12px;
  margin-top: 16px;
}

.customer-modal-link-hD5D0 {
  min-width: 0px;
  flex-grow: 1;
  color: var(--color-neutral-800);
  font-family: var(--font-mono);
  font-size: 14px;
  line-height: 18px;
  overflow-wrap: anywhere;
}

.customer-modal-copyButton-PuvJU {
  flex-shrink: 0;
}

`, "",{"version":3,"sources":["webpack://./src/pages/customer/customer-user/customer-modal/customer-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,QAAQ;EACR,uCAAuC;EACvC,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".modal_card {\n  width: 324px;\n  height: auto;\n  min-height: auto;\n  max-height: 600px;\n}\n\n.modal_content {\n  padding: 0px 20px 0px;\n}\n\n.detailItem_container {\n  width: auto;\n  flex-wrap: wrap;\n  row-gap: 12px;\n  column-gap: 16px;\n  padding: 18px 0px;\n}\n\n.detailItem_title {\n  font-size: 15px;\n  font-weight: normal;\n}\n\n.detailItem_text {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.linkSection {\n  margin-top: 16px;\n}\n\n.linkHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.active {\n  flex-shrink: 0;\n  color: var(--color-green-700);\n  font-size: 12px;\n  font-weight: 500;\n  background-color: var(--color-green-50);\n  border-radius: var(--radius-xl);\n  padding: 5px 9px;\n}\n\n.linkTitle {\n  color: var(--color-neutral-800);\n  font-size: 15px;\n}\n\n.linkRow {\n  display: flex;\n  min-width: 0px;\n  align-items: flex-start;\n  gap: 8px;\n  background-color: var(--color-gray-100);\n  border-radius: var(--radius-lg);\n  padding: 7px 7px 7px 12px;\n  margin-top: 16px;\n}\n\n.link {\n  min-width: 0px;\n  flex-grow: 1;\n  color: var(--color-neutral-800);\n  font-family: var(--font-mono);\n  font-size: 14px;\n  line-height: 18px;\n  overflow-wrap: anywhere;\n}\n\n.copyButton {\n  flex-shrink: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `customer-modal-modal_card-OVQlA`,
	"modal_content": `customer-modal-modal_content-FwvZH`,
	"detailItem_container": `customer-modal-detailItem_container-zYkHD`,
	"detailItem_title": `customer-modal-detailItem_title-MRmGP`,
	"detailItem_text": `customer-modal-detailItem_text-OQWpa`,
	"linkSection": `customer-modal-linkSection-sQZ4C`,
	"linkHeader": `customer-modal-linkHeader-pvXkZ`,
	"active": `customer-modal-active-SUQ69`,
	"linkTitle": `customer-modal-linkTitle-vqSPD`,
	"linkRow": `customer-modal-linkRow-oHyk2`,
	"link": `customer-modal-link-hD5D0`,
	"copyButton": `customer-modal-copyButton-PuvJU`
};
export default ___CSS_LOADER_EXPORT___;
